export default __webpack_public_path__ + "static/media/libptop.147080ad.ico";